import React from "react";
import appStore from "../img/appstore.svg";
import googlePlay from "../img/google-play.svg";

function AppStoreLink() {
    const appStoreUrl = "https://apps.apple.com/nl/app/drvr-2/id6479655966";
    const googlePlayUrl = "https://play.google.com/store/apps/details?id=com.zandorsmith.DRVRReactNative&hl=nl";

    return (
        <div className="mt-4" style={{maxWidth: "200px", width: "100%"}}>
            <a
                href={appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src={appStore}
                    alt="App Store"
                    className="img-fluid"
                />
            </a>
            <a
                href={googlePlayUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get it on Google Play"
                className="d-block mt-2"
            >
                <img
                    src={googlePlay}
                    alt="Google Play"
                    className="img-fluid"
                />
            </a>
        </div>
    );
}

export default React.memo(AppStoreLink);
